import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const DotsMenuOutline = createIcon({
  displayName: 'DotsMenuOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M18.5 12v0c0 .276142-.223858.5-.5.5 -.276142 0-.5-.223858-.5-.5 0-.276142.223858-.5.5-.5h-2.18557e-08c.276142-1.20706e-08.5.223858.5.5"></path>
        <path d="M12.5 12v0c0 .276142-.223858.5-.5.5 -.276142 0-.5-.223858-.5-.5 0-.276142.223858-.5.5-.5h-2.18557e-08c.276142-1.20706e-08.5.223858.5.5"></path>
        <path d="M6.5 12v0c0 .276142-.223858.5-.5.5 -.276142 0-.5-.223858-.5-.5 0-.276142.223858-.5.5-.5h-2.18557e-08c.276142-1.20706e-08.5.223858.5.5"></path>
      </g>
      <path fill="none" d="M24 0v24h-24v-24Z"></path>
    </>
  ),
})

const DotsMenu: FC<CustomIconProps> = (props) => {
  return <CustomIcon as={DotsMenuOutline} {...props} />
}

export default memo(DotsMenu)
